<template>
    <div class="filters-wrapper">
        <rw-autocomplete 
            :hide-label="true" 
            :location-text="searchParams.location_txt"
            @selection="onLocationSearchSelect">
        </rw-autocomplete>
        <label for="rwps-listing-type-input" class="rwfc rwfc--select rwps__search-type-input-wrapper d-none d-lg-block mb-0 mr-md-1">
            <span class="sr-only">Search Type</span>
            <div class="rwfc__dropdown-triangle-layer">
              <select 
                  id="rwps-listing-type-input"
                  class="rwfc__input"
                  @change="$emit('search-type-change', $event.target.value)">
                  import Select2Multiple from "@vue/components/select2/Select2Multiple.vue";
                  <option value="for-sale" :selected="searchType == 'for-sale'">For Sale</option>
                  <option value="for-rent" :selected="searchType == 'for-rent'">For Rent</option>
              </select>
            </div>
        </label>

        <div class="rw-building-types-multiple mb-0 mr-md-1">
          <select2-multiple
            :input-name="'building_types'"
            :input-id="'rwrw-building-types'"
            :label-text="'Building Types'"
            :place-holder-text="'All Property Types'"
            v-model="buildingTypes"
            :options="select2BuildingTypes"
          >
            <template slot="options" slot-scope="{ options }">
              <option
                v-for="option in options"
                :key="option.id"
                :value="option.id"
                :selected="searchParams.building_types.includes(option.text)"
              >
                {{ option.text }}
              </option>
            </template>
          </select2-multiple>
        </div>
        
        <filter-dropdown
            :dropdown-id="'rwps-filters-bar-asking-price-filter-dropdown'"
            :field-label="priceFieldLabel || 'Price'"
            :is-active="priceFieldLabel !== false"
            :extra-classes="'d-none d-md-block mr-md-1'"
        >
            <min-max-controls
                :min-symbol-before="'$'"
                :max-symbol-before="'$'"
                :min-el-id="'rwps-filters-bar-min-asking-price'"
                :max-el-id="'rwps-filters-bar-max-asking-price'"
                :min-val="searchParams[`min_asking_price`]"
                :max-val="searchParams[`max_asking_price`]"
                :min-wrapper-class="errors[`min_asking_price`].$error ? 'rwfc--error' : ''"
                :max-wrapper-class="errors[`max_asking_price`].$error ? 'rwfc--error' : ''"
                :min-label="'Minimum Price'"
                :max-label="'Maximum Price'"
                @min-value-changed="emitFilterChange({[`min_asking_price`]: $event})"
                @max-value-changed="emitFilterChange({[`max_asking_price`]: $event})">
            </min-max-controls>
        </filter-dropdown>
        <filter-dropdown
            :field-label="bedsLabel || 'Beds'"
            :is-active="bedsLabel !== false"
            :extra-classes="'d-none d-md-block mr-md-1'">
            <min-max-controls
                :min-el-id="'rwps-filters-bar-min_beds'"
                :max-el-id="'rwps-filters-bar-max_beds'"
                :min-val="searchParams.min_beds"
                :max-val="searchParams.max_beds"
                :min-label="'Minimum Beds'"
                :max-label="'Maximum Beds'"
                @min-value-changed="emitFilterChange({min_beds: parseFloat($event)})"
                @max-value-changed="emitFilterChange({max_beds: parseFloat($event)})">
            </min-max-controls>
        </filter-dropdown>
        <template v-if="searchType == 'for-sale'">
            <filter-dropdown
                :field-label="grossYieldLabel || 'Gross Yield'"
                :is-active="grossYieldLabel !== false"
                :extra-classes="'d-none d-md-block'">
                <min-max-controls
                    :min-symbol-after="'%'"
                    :max-symbol-after="'%'"
                    :min-el-id="'rwps-filters-bar-min_gross_yield'"
                    :max-el-id="'rwps-filters-bar-max_gross_yield'"
                    :min-val="searchParams[`min_gross_yield`]"
                    :max-val="searchParams[`max_gross_yield`]"
                    :min-label="'Minimum Gross Yield'"
                    :max-label="'Maximum Gross Yield'"
                    @min-value-changed="emitFilterChange({min_gross_yield: parseFloat($event)})"
                    @max-value-changed="emitFilterChange({max_gross_yield: parseFloat($event)})">
                </min-max-controls>
            </filter-dropdown>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getPricingLabel, getBedsLabel, getGrossYieldLabel, getROILabel } from '@vue/store/helpers';
import PropertySearchFiltersMixin from '@vue/mixins/property-search-filters-mixin';

import LocationSearchInput from '@vue/components/inputs/LocationSearchInput.vue';
import MinMaxControls from '@vue/components/inputs/MinMaxControls.vue';
import FilterDropdown from '@vue/components/util/FilterDropdown.vue';
import RwAutocomplete from '@vue/components/inputs/RwAutocomplete.vue';
import Select2Multiple from "@vue/components/select2/Select2Multiple.vue";

export default {
    components: {
        LocationSearchInput,
        MinMaxControls,
        FilterDropdown,
        RwAutocomplete,
        Select2Multiple
    },
    mixins: [PropertySearchFiltersMixin],
    props: {
        errors: {},
        searchType: { type: String },
        selectedLocation: { type: Object },
        showFilterDrawer: {},
        buildingTypeDropdownOptions: { type: Object, required: true},
        select2BuildingTypes: { type: Array, required: true },
    },
    data(){
        return {
            isSearch: true
        }
    },
    computed: {
        
        ...mapState('propertySearchStore', [
            'searchParams'
        ]),

        buildingTypes: {
          get() {
            return this.searchParams.building_types;
          },
          set(value) {
            this.emitFilterChange({ building_types: value });
          },
        },

        priceFieldLabel(){

            return getPricingLabel(this.activeFilters, this.searchType)
          
        },

        bedsLabel(){
          return getBedsLabel(this.activeFilters)
        },

        grossYieldLabel(){
          return getGrossYieldLabel(this.activeFilters)
        },

        roiLabel(){
          return getROILabel(this.activeFilters)
        }
    },
    methods: {
        
        onLocationSearchSelect($event){
            this.$emit('location-search-change', $event);
        }
    }
};
</script>